<template>
    <v-container class="ma-0 pa-0 intro_container" fluid fill-height>
        <v-img :src="require('@/assets/images/renew/bg-elements.png')" style="position:absolute; top:0; height:100vh; width:100vw;" />
        <v-row class="ma-0 mt-4 pa-0 px-6">
            <v-col cols="12" align-self="start" align="center" class="intro_title_img">
                <v-img :src="require('@/assets/images/renew/home-logo-selvychckup.png')" width="122" height="19"/>
            </v-col>
            <div class="main-container">
                <div class="title-main">
                    <p style="font-size:24px; margin-bottom:0; color:#193263;">질병위험도 분석</p>
                    <p style="font-size:24px; margin-bottom:0; color:#3f6fff;">AI 건강 리포트</p>
                </div>
                <div class="desc">
                    <!-- 셀비 체크업은 인공지능 기반으로 당신의 건강 검진 결과를 분석하여 가까운 미래의 주요 질환에 대한 발병 위험도를 예측해 드립니다.-->
                    셀비 체크업은 인공지능 기반으로 주요 10개 질환에 대하여 당신과 실제 발병자와의 건강 수치 유사도를 분석한 건강 리포트를 제공해 드립니다.
                </div>
            </div>

            <!-- <div class="row-2">
                <img src="../assets/images/renew/bg-mockup.png" class="intro-img">
            </div> -->

            <v-col cols="12" align-self="center" align="center" class="my-10 pa-0">
                <v-img :src="require('@/assets/images/renew/bg-mockup.png')" :width="mockupWidth" :height="mockupHeight" />
            </v-col>

            <!-- <div class="footer">
                <div class="button-wrapper">
                    <button class="button primaries" @click="goHelloCheckup" v-ripple tabindex="1">간단히 분석해 보기</button>
                    <button class="button default" @click="goCheckupApp" v-ripple tabindex="2">더 자세히 분석해 보기</button>
                </div>
            </div> -->
            <v-introduction-popup
                v-if="introductionPopup"
                @closePopup="OnClosePopup"
            />
        </v-row>
        <v-row class="ma-0 pa-5 footer_btn_group">
            <v-col cols="12" align-self="end" align="center" class="pa-0 ma-0">
                <v-btn 
                    elevation="0" 
                    block
                    tile
                    @click="goHelloCheckup" 
                    v-ripple 
                    x-large 
                    tabindex="1" 
                    color="#193263" 
                    height="48" 
                    style="color:#fff; font-size:16px; letter-spacing:0.01em;"
                > 
                    간단히 분석해 보기 
                </v-btn>
            </v-col>
            <v-col cols="12" align-self="end"  align="center" class="pa-0 ma-0">
                <v-btn elevation="0" block tile @click="goCheckupApp" v-ripple x-large tabindex="2" height="48" style="color:#193263; font-size:16px; letter-spacing:0.01em; font-weight:700;"> 더 자세히 분석해보기 </v-btn>
            </v-col>
        </v-row>
    </v-container>

    
</template>
<script>
    import { mapActions } from 'vuex'
    import VIntroductionPopup from "@/components/popup/introductionPopup.vue";
    export default {
        components: {
            VIntroductionPopup,
        },
        data() {
            return {
                introductionPopup: false,
                introHeight: 760,
                mockupWidth: 208,
                mockupHeight: 321
            }
        },
        computed: {
            isOrange () {
                return this.$route.query.orange === 'true'
            }
        },
        mounted() {
            console.log('configuration : ', process.env)
            this.introHeight = window.innerHeight * 0.5
            // // this.mockupWidth = mockupWidth
            // this.mockupHeight = window.innerHeight * 0.45
        },
        methods: {
			...mapActions('survey', [
				'setStep'
			]),
            //간단한 예측
            goHelloCheckup() {
                this.setStep(1)
                this.$router.push("/userTerms")
                //this.$router.push('/checkup/reportOverview')
            },
            //자세한 예측
            goCheckupApp() {
                this.introductionPopup = true;
            },
            OnClosePopup() {
				this.introductionPopup = false;
            }
        }
    }
</script>
<style scoped lang="scss">

    .main-container {
        font-family: "NanumSquare", sans-serif;
        text-align: center;
        padding: 0 30px;
        max-width: 500px;
        //margin: auto;
        z-index:1;
        margin-top:21px;
    }
    .bi-img {
        margin-top: 40px;
        margin-bottom: 26px;
        width: 360px;
    }

    .title-main {
        font-weight: 700;
    }
    .desc {
        margin-top:10px;
        font-size: 12px;
        color: #193263;
        word-break: keep-all;
        font-family: "NanumSquare", sans-serif;
    }
    .row-2 {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        margin: auto;
    }
    .intro-img {
        text-align: center;
        width: 70vw;
        max-width: 280px;
    }
    .footer {
        position: fixed;
        bottom:20px;
        // max-width: 500px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: auto;
    }
    
    @media all and (max-height: 600px) {
        .row-2 {
            height: auto;
        }
    }

    .intro_container {
        font-family: "NanumSquare", sans-serif;
        background-image: url('../assets/images/renew/bg-3x.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        align-items: baseline !important;
    }

    // .footer_btn_group {
    //     position: fixed;
    //     bottom:0;
    // }

    // @media screen and (max-height: 680px)
    // {   
    //     .footer_btn_group {
    //         position: relative;
    //         align-self: flex-end;
    //     }
    // }
</style>
